import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-team-stacking/actions';

class TeamPPLines extends Component {
    onChange(ppLine, isChecked) {
        this.props.dispatch(
            Action.setTeamPPLinesForStackNumber({[ppLine]: isChecked}, this.props.team, this.props.stackNumber),
        );
    }

    render() {
        const {team, stackNumber, stacking} = this.props;
        const ppLines = stacking.getTeamPPLines(stackNumber, team);

        return (
            <div className="chk-group-container">
                <span className="chk-group-title">PP Lines:</span>
                <div className="chk-group">
                    {Object.keys(ppLines).map((ppLine) => {
                        return (
                            <label key={ppLine}>
                                <input
                                    type="checkbox"
                                    checked={ppLines[ppLine]}
                                    onChange={(e) => ::this.onChange(ppLine, e.target.checked)}
                                />
                                <span>{ppLine}</span>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(TeamPPLines);
